var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"id":_vm.id,"title":'Create Payment Link',"toggle":_vm.closeModal}},[(_vm.successMsg)?_c('SuccessState',{attrs:{"message":'Payment Link Created Successfully',"onSuccess":_vm.handleRefetch}}):_c('PaymentLinkForm',{attrs:{"onSuccess":_vm.onSuccess,"closeModal":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }